import React from 'react'
import { Col, Container, Row } from "reactstrap";
import { Link } from 'react-router-dom';
import Supplymetrics from '../../../Assets/Images/supplymetrics.png';
import Propertiesamenitydetails from '../../../Assets/Images/propertiesamenitydetails.png';
import Demandanalysis from '../../../Assets/Images/demandanalysis.png';
import Demographics from '../../../Assets/Images/demographics.png';
import Instantreports from '../../../Assets/Images/instantreports.png';
import HubspotForm from 'react-hubspot-form';


const RVParksMarketData = () => {
    return (
        <div>
          <div className='about-us pt-5 pb-5 mb-4 rvparkmarketdata-section' >
                    <Container>
                        <Row>
                            <Col md={12} lg={6} className='about-content'>
                                <div>
                                    <h1>Kickstart your RV park and campgrounds market analysis journey with our Explorer platform</h1>
                                    <div className='mt-5'><button onClick={()=> {
                                        const scrorableDiv = document.getElementById("placed-section");
                                        if (scrorableDiv) {
                                            // Use scrollIntoView to scroll smoothly to the div
                                            scrorableDiv.scrollIntoView({
                                              behavior: 'smooth', // Smooth scroll
                                              block: 'start', // Align to the top of the viewport
                                            });
                                          }

                                    }} className='rvparkbooklive'> Book a live demo with us today! </button> </div>
                                </div>
                                
                            </Col>
                           
                        </Row>
                    </Container>
                </div>
    
                <div>
                <Container className='rvparkmd'>
                    <Row>
                    <Col className='mb-4'>
                    <div className='bg-white'>
                        <div className='bg-white-icon'>  <img src={Supplymetrics} alt="Supplymetrics" /></div>
                        <div className='bg-white-text'> Supply <br/> Metrics</div>
                    </div>
                    </Col>
                    <Col className='mb-4'>
                    <div className='bg-white'>
                        <div className='bg-white-icon'>  <img src={Propertiesamenitydetails} alt="propertiesamenitydetails" /></div>
                        <div className='bg-white-text'> Properties & Amenity Details</div>
                    </div>
                    </Col>
                    <Col className='mb-4'>
                    <div className='bg-white'>
                        <div className='bg-white-icon'>  <img src={Demandanalysis} alt="Demandanalysis" /></div>
                        <div className='bg-white-text'> Demand <br/> Analysis</div>
                    </div>
                    </Col>
                    <Col className='mb-4'>
                    <div className='bg-white'>
                        <div className='bg-white-icon'>  <img src={Demographics} alt="Demographics" /></div>
                        <div className='bg-white-text'> Demographics</div>
                    </div>
                    </Col>
                    <Col className='mb-2'>
                    <div className='bg-white'>
                        <div className='bg-white-icon'>  <img src={Instantreports} alt="instantreports" /></div>
                        <div className='bg-white-text'> Instant <br/> Reports</div>
                    </div>
                    </Col>
                    </Row>
                </Container>
                </div>

                <div className='mb-5 pb-2' id="placed-section">
                <Container >
                    <Row>
                        <div className='rvparkqi-head'>
                        Get Started with RVPark<span className='rvparkiq-color'>IQ</span>
                        </div>
                        <p className='rvparkqi-prag col-md-8 mx-md-auto'>Ready to explore smarter investments in RV parks and campgrounds? Fill out the form to request a personalized demo of our market analysis platform. One of our experts will reach out within one business day to schedule your demo.</p>
                        <p className='rvparkqi-prag-freetrial '>Can't wait? Start analyzing today with a <a href='/account-subscription?type=free'>free trial</a>!</p>
                        <div className='contactform-shadow'>
                            <div className='formdesignpad'>
                            <HubspotForm
                    portalId='4297816'
                    formId='4d82fd88-3579-4954-991e-b2ba6bbe6635'
                    cssClass="rvparkiq-demo"
                    css=""
                  />
                            </div>
                        </div>

                    </Row>
                </Container>
                </div>
        </div>
      )
}

export default RVParksMarketData






